export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_top_En.603f51ca.webp";